<template>
    <v-dialog v-model="showConfigDialog" max-width="700">
        <template v-slot:activator="{ on, attrs }">
            <div v-on="on" v-bind="attrs">
                <slot></slot>
            </div>
        </template>
        <v-card>
            <v-card-title>{{ $t('Home.dashboard.myBuyListsConfig.title') }}</v-card-title>
            <v-list flat subheader three-line>
                <v-subheader>{{ $t('Home.dashboard.myBuyListsConfig.description') }}</v-subheader>
                <v-divider></v-divider>
                <v-subheader>{{ $t('Home.dashboard.myBuyListsConfig.calculator.title') }}</v-subheader>
                <v-list-item-group v-model="settings" active-class="primary--text">
                    <v-list-item>
                        <template v-slot:default="{ active }">
                            <v-list-item-action>
                                <v-checkbox :input-value="active"></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('Home.dashboard.myBuyListsConfig.calculator.52LastWeeks.title') }}</v-list-item-title>
                                <v-list-item-subtitle>{{ $t('Home.dashboard.myBuyListsConfig.calculator.52LastWeeks.description') }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </v-list-item>
                    <v-list-item>
                        <template v-slot:default="{ active }">
                            <v-list-item-action>
                                <v-checkbox :input-value="active"></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('Home.dashboard.myBuyListsConfig.calculator.thresholds.title') }}</v-list-item-title>
                                <v-list-item-subtitle>{{ $t('Home.dashboard.myBuyListsConfig.calculator.thresholds.description') }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </v-list-item>
                    <v-list-item>
                        <template v-slot:default="{ active }">
                            <v-list-item-action>
                                <v-checkbox :input-value="active"></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('Home.dashboard.myBuyListsConfig.calculator.thresholdsFlex.title') }}</v-list-item-title>
                                <v-list-item-subtitle>{{ $t('Home.dashboard.myBuyListsConfig.calculator.thresholdsFlex.description') }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
            <v-card-actions>
                <SaveCancelButtons align="end" @saveAsked="submit" @cancelAsked="cancel"></SaveCancelButtons>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import SaveCancelButtons from '../../components/controls/SaveCancelButtons.vue';
import ListRegularIconMixin from '../../components/help/icons/ListRegularIconMixin';
export default {
	components: { SaveCancelButtons },
    mixins: [ListRegularIconMixin],
    data() {
        return {
            showConfigDialog: false,
            scoreCalculationPreference: {},
            settings: null
        }
    },
    created() {
        this.scoreCalculationPreference = this.getScoreCalculationBuyListInfos;
        if (this.scoreCalculationPreference) {
            this.setConfig(this.scoreCalculationPreference);
        }
    },
    computed: {
        getScoreCalculationBuyListInfos() {
            return this.$store.getters.getScoreCalculationBuyListInfos;
        }
    },
    methods: {
        open() {
            this.showConfigDialog = true;
        },
        close() {
            this.showConfigDialog = false;
        },
        setConfig(config) {
            if (config.fallbackStrategyName) {
                this.settings = 2
            }
            else {
                this.settings = config.distribution.fiftyTwoWeeks === 1 ? 0 : config.distribution.thresholds === 1 ? 1 : null;
            }
        },
        getConfig() {
            if (this.settings === 2) {
                return {
                    fallbackStrategyName: 'fiftyTwoWeeks',
                    distribution: {
                        fiftyTwoWeeks: 0,
                        thresholds: 1
                    }
                }
            }
            return {
                distribution: {
                    fiftyTwoWeeks: this.settings === 0 ? 1 : 0,
                    thresholds: this.settings === 1 ? 1 : 0
                }
            }
        },
        submit() {
            this.scoreCalculationPreference = this.getConfig();
            this.$store.dispatch('addOrUpdateScoreCalculationBuyListInfos', { ...this.scoreCalculationPreference })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.close();
                });
        },
        cancel() {
            this.close();
        }
    },
    watch: {
        getScoreCalculationBuyListInfos: {
            handler: function (val) {
                this.scoreCalculationPreference = val;
                this.setConfig(val);
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>

</style>